<template>
  <div id="chat-group-set">
    <Nav>
      <i class="el-icon-arrow-left btn" slot="prefix" @click="$router.back()"></i>
      群设置
    </Nav>
    <el-tabs v-model="activeName" :stretch="true" @tab-click="handleClick">
      <el-tab-pane :label="'项目列表(' + keys.length + ')'" class="tab-project" name="project">
        <div class="user-list" v-if="false">
          <div v-for="(item, idx) in keys" :key="idx" class="keyword">
            <span class="href" @click="toMessage(item)">{{item.title}}</span>
            <el-tag
              :type="item.status === 1 ? 'success' : 'warning'"
            >{{item.status === 1 ? "完成" : "讨论中"}}</el-tag>
          </div>
        </div>
        <Topics :keys="keys" @toMessage="toMessage" />
      </el-tab-pane>
      <el-tab-pane :label="'群成员(' + users.length + ')' " name="user">
        <UserList
          :users="users"
          :chatMessage="chatMessage"
          :currentGroup="id"
          @delUser="delUser"
          @complete_event="addComplete"
          @userHandle="userHandle"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Nav from "@/components/Nav";
import UserList from "@/components/UserList";
import Topics from "@/components/Topics";
export default {
  props: { id: [String, Number] },
  components: { Nav, UserList, Topics },
  data() {
    return {
      activeName: "project",
      users: [],
      chatMessage: { chats: [{ name: "", date: "" }] },
      current_group: localStorage.getItem("group"),
      keys: []
    };
  },
  created() {
    this.getChat(this.id)
    this.getGroupUser(this.id);
    this.getProject(this.id);
  },
  methods: {
    handleClick(tab) {
      if (tab.name == "project") {
        this.getProject(this.id);
      } else if (tab.name == "user") {
        this.getGroupUser(this.id);
      }
    },
    userHandle() {
      this.showUser = true;
    },
    addComplete(isPass) {
      // this.showUser = false;
      console.log("add complete:", this.id, isPass);
      if (isPass) {
        this.getGroupUser(this.id);
      } else {
        this.getChat(this.id);
        if (this.id) {
          // this.showChat(this.id);
        }
      }
    },
    delUser(idx) {
      this.users.splice(idx, 1);
    },
    toMessage(item) {
      // console.log('to message:',item)
      if (item.download == 1) {
        this.$router.push({ path: "/message", query: { mid: item.room_id } });
      }
    },
    getProject(id) {
      this.$api.getRoomInfo({ id: id, project: true }).then(res => {
        this.keys = res.result.projects;
      });
    },
    getGroupUser(id) {
      this.$api.getRoomInfo({ id: id, users: true }).then(res => {
        this.users = [...res.result.users];
      });
    },
    getChat(id) {
      this.$api.getChat({ id: id }).then(res => {
        this.chatMessage = res.result.chat;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#chat-group-set {
}
</style>